import { render } from "./FlyoutMenuItems.vue?vue&type=template&id=58ac64fb&scoped=true"
import script from "./FlyoutMenuItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyoutMenuItems.vue?vue&type=script&setup=true&lang=js"

import "./FlyoutMenuItems.vue?vue&type=style&index=0&id=58ac64fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ac64fb"],['__file',"src/components/Ui/FlyoutMenuItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58ac64fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58ac64fb', __exports__)) {
    api.reload('58ac64fb', __exports__)
  }
  
  module.hot.accept("./FlyoutMenuItems.vue?vue&type=template&id=58ac64fb&scoped=true", () => {
    api.rerender('58ac64fb', render)
  })

}


export default __exports__